var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.itemType === 'coin' || _vm.itemType === 'ticket' || _vm.itemType === 'ad_ticket'
  )?_c('span',{staticClass:"ico_badge",class:{
    ico_coin: _vm.itemType == 'coin',
    ico_ticket: _vm.itemType === 'ticket' || _vm.itemType === 'ad_ticket'
  }}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }